import type { UserProfileJSONObject } from '@ikegps/core-api';
import { IkeRestObject } from './base';

export class IkeObjectUserProfile extends IkeRestObject<UserProfileJSONObject> {
	className = 'UserProfile' as const;
	actionName = 'user.profile';
	object?: UserProfileJSONObject;
}
